import { render } from "./SchedulerJavaClassAccordion.vue?vue&type=template&id=87525d5e&scoped=true&ts=true"
import script from "./SchedulerJavaClassAccordion.vue?vue&type=script&lang=ts"
export * from "./SchedulerJavaClassAccordion.vue?vue&type=script&lang=ts"

import "./SchedulerJavaClassAccordion.vue?vue&type=style&index=0&id=87525d5e&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87525d5e"]])

export default __exports__